import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton, Tooltip } from '@pulse/ui';
import { useState } from 'react';

// Shared "copy a link to the clipboard" affordance. Two mutually exclusive modes:
// - `path`: copies this record's permalink (`window.location.origin` + path) — used on
//   IssueDetailDialog and the Risk/Dependency/Escalation/ChangeRequest FormDialogs' title bars,
//   only once a record actually has a stable URL (i.e. never shown while creating a brand-new
//   record).
// - `url`: copies an already-absolute external URL verbatim, with no origin prefix — used for a
//   user-entered link value (e.g. ProjectOverviewTab's Document Folder Link).
type CopyLinkButtonProps = { path: string; url?: undefined } | { path?: undefined; url: string };

export function CopyLinkButton({ path, url }: CopyLinkButtonProps) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    await navigator.clipboard.writeText(url ?? `${window.location.origin}${path}`);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <Tooltip title={copied ? 'Link copied!' : 'Copy link'}>
      <IconButton size="small" onClick={() => void handleCopy()} aria-label="Copy link">
        <ContentCopyIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
